import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MainProvider } from './common/MainContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //If React.StrictMode set, useEffect runs twice (ML 09-17-2023)
  //<React.StrictMode>
  <MainProvider>
    <App />
  </MainProvider>
  //</React.StrictMode>
);

reportWebVitals();
